import { apiService } from './api';
import { useAppStore } from '../store/appStore';

/**
 * Switches the app session to `businessId` via /auth/select-business: a
 * fresh business-scoped access token (with the current subscription in its
 * claims) plus a STORED refresh token. Used after business creation and
 * after every plan/payment change — tokens minted elsewhere (e.g. the
 * business-create response) had no stored refresh token, so the session
 * died when the access token expired.
 */
export async function activateBusinessSession(businessId: string): Promise<boolean> {
  const response = await apiService.selectBusiness(businessId);
  if (response.statusCode !== 1000 || !response.data) return false;
  const { token, refreshToken } = response.data as any;
  apiService.setAuthToken(token);
  apiService.setRefreshToken(refreshToken);
  const store = useAppStore.getState();
  await store.setAuthState({
    tokens: { token, refreshToken },
    user: store.user || {
      id: '', email: '', firstName: '', lastName: '', username: '',
      isEmailVerified: true, isActive: true,
      createdAt: new Date().toISOString(), updatedAt: new Date().toISOString(),
    },
    source: 'login',
  });
  store.setPhase1Token(null);
  return true;
}
